import Handlebars from 'handlebars/dist/cjs/handlebars';
import Modal from '../../components/modal/index';
import Glide from '@glidejs/glide';
import CounterChilds from '../../utils/counter-childs';
import PerfectScrollbar from 'perfect-scrollbar';
import axios from 'axios';

import '../../utils/handlebars.attr';
import '../../utils/handlebars-ifCond';
import '../../utils/handlebars-asset';
import '../../utils/handlebars-truncate';

import { API_PATH } from '../../constants';

(() => {
    const selectors = {
        hbsSource       : 'hbs-template__js',
        hbsTemplate     : 'hbs-template',
        hbsSourceDesc   : 'hbs-template__js-desc',
        hbsTemplateDesc : 'hbs-template-desc',
        scrollDesc      : 'clip-scroll',
        wrapper         : '.template',
        btnMore         : '.btn-more-tips',
        select          : 'select-tips',
        item            : '.article-list__item',
        modal           : '#modal-slideshow',
        btnPlay         : '.btn-play'
    };

    const cssClasses = {
        loading   : 'is-loading',
        firstLoad : 'is-first-load'
    };

    let indexPage      = 1;
    let totalPages     = 1;
    const limit        = 6;
    const arrTips      = { tips: [] };
    const videoDesc    = { info: {} };
    const source       = document.getElementById(selectors.hbsSource).innerHTML;
    const template     = Handlebars.compile(source);
    const sourceDesc   = document.getElementById(selectors.hbsSourceDesc).innerHTML;
    const templateDesc = Handlebars.compile(sourceDesc);

    if (CounterChilds('.glide') > 0) {
        new Glide('.glide', {
            type          : 'slide',
            gap           : 0,
            dragThreshold : false,
            dragDistance  : false,
            autoplay      : 4000
        }).mount();   
    }

    function getTips({
        category = '',
        page     = 1,
        orderby  = 'asc'
    } = {}) {
        isLoading(true);

        axios.get(`${API_PATH}/tips`, {
            params: {
                category : category,
                page     : page,
                orderby  : orderby,
                limit    : limit
            }
        })
            .then((response) => {
                if (response.data.success) {
                    const data = response.data.data;

                    // console.log('DATA', response.data);

                    data.map((tip) => {
                        const data = {
                            id          : tip.id,
                            type        : tip.type,
                            thumb       : tip.thumb,
                            title       : tip.title,
                            description : tip.description,
                            slug        : tip.slug,
                            video_url   : tip.video_url ? tip.video_url.split('v=')[1] : ''
                        }
            
                        arrTips.tips.push(data);
                    });
            
                    document.getElementById(selectors.hbsTemplate).innerHTML = template(arrTips);
                    
                    isLoading(false);
                    onClickThumb();
                    renderPagination(response.data.page, response.data.total, limit);

                    // console.log(arrTips);
                } else {
                    isLoading(false);
                    console.log('GET Error ->', response.data.message);
                }
            })
            .catch((error) => {
                isLoading(false);
                console.warn('GET Error', error);
            });
    }

    function onClickThumb() {
        Array.prototype.slice
            .call(document.querySelectorAll(".article-list__link[data-type='video']"))
                .map((item) => {
                    item.addEventListener('click', (evt) => {
                        evt.preventDefault();

                        const vID       = evt.currentTarget.getAttribute('data-video-id');
                        const videoInfo = arrTips.tips.filter((elem, i, arr) => arr.indexOf(elem) == item.id);
                        
                        openVideo(vID, videoInfo);
                    });
                });
    }

    function isLoading(bool) {
        if (bool) {
            document.getElementById(selectors.select).disabled = true;
            document.getElementById(selectors.hbsTemplate).classList.add(cssClasses.loading);
            document.querySelector(selectors.btnMore).classList.add(cssClasses.loading);
        } else {
            if (document.querySelector(selectors.wrapper).classList.contains(cssClasses.firstLoad)) {
                document.querySelector(selectors.wrapper).classList.remove(cssClasses.firstLoad);
            }

            document.getElementById(selectors.select).disabled = false;
            document.getElementById(selectors.hbsTemplate).classList.remove(cssClasses.loading);
            document.querySelector(selectors.btnMore).classList.remove(cssClasses.loading);
        }
    };

    function addScroll() {
        let titleHeight = document.getElementById('clip-title').offsetHeight;

        if (window.innerWidth > 768) {
            document.getElementById(selectors.scrollDesc).style.height = `${ 460 - (titleHeight + 30)}px`;
            new PerfectScrollbar(document.getElementById(selectors.scrollDesc), { suppressScrollX: true });
        } else {
            document.getElementById(selectors.scrollDesc).style.height = `${ window.innerHeight - (titleHeight + 70)}px`;
        }
    };

    function renderPagination(index, totalItems, limitPerPage) {
        indexPage  = parseInt(index, 10);
        totalPages = totalItems > 0 ? Math.ceil(totalItems/limitPerPage) : 0;

        if (totalPages > indexPage) {
            renderPaginationButton(true);
        } else {
            renderPaginationButton(false);
        }
    };

    function renderPaginationButton(bool) {
        if (bool) {
            document.querySelector(selectors.btnMore).disabled = false;
            document.querySelector(selectors.btnMore).style.display = 'block';
        } else {
            document.querySelector(selectors.btnMore).disabled = true;
            document.querySelector(selectors.btnMore).style.display = 'none';
        }
    };

    function openVideo(id, data) {
        const modal = new Modal(selectors.modal, false);
        
        videoDesc.info = {
            title       : data[0].title,
            description : data[0].description
        };

        modal.openModal();

        if (player) player.loadVideoById(id);
        document.getElementById(selectors.hbsTemplateDesc).innerHTML = templateDesc(videoDesc);
        addScroll();
    }
    
    document.getElementById(selectors.select).addEventListener('change', (evt) => {
        arrTips.tips = [];
        getTips({ category: evt.target.value });
    });

    document.querySelector(selectors.btnMore).addEventListener('click', () => {
        getTips({ page: ++indexPage });
    });

    Array.prototype.slice
        .call(document.querySelectorAll(selectors.btnPlay))
            .map((item) => {
                item.addEventListener('click', (evt) => {
                    evt.preventDefault();
                    
                    const loading = evt.currentTarget;
                    const ID      = item.getAttribute('data-tip-id');
                    const vID     = item.getAttribute('data-video-id').split('v=')[1];
                    
                    loading.classList.add(cssClasses.loading);

                    axios.get(`${API_PATH}/tips`, { params: { ids: ID } })
                        .then((response) => {
                            if (response.data.success) {
                                const data = response.data.data;
                                loading.classList.remove(cssClasses.loading);
                                openVideo(vID, data);
                            } else {
                                loading.classList.remove(cssClasses.loading);
                                console.log('GET Error TIP ID ->', response.data.message);
                            }
                        })
                        .catch((error) => {
                            loading.classList.remove(cssClasses.loading);
                            console.warn('GET Error TIP ID', error);
                        });
                });

                item.addEventListener('mouseover', () => {
                    document.querySelector('.glide__slide--active .glide__picture').classList.add('over');
                });

                item.addEventListener('mouseout', () => {
                    document.querySelector('.glide__slide--active .glide__picture').classList.remove('over');
                });
            });
            
    getTips();
})();
